import { ButtonTabs } from "../components/ui";
import { useEffect } from "react";
import { Stack } from "@mui/system";
import { AccountPlanReports } from "../components/company";
import { PlaybookReports } from "../components/company/reports";
import { useStateWithSearchParams } from "../hooks";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../types/enums";

enum TabsEnum {
  plan = "Account Plan",
  playbook = "Playbook",
}

const mapper = {
  [TabsEnum.plan]: <AccountPlanReports />,
  [TabsEnum.playbook]: <PlaybookReports />,
};

export const AccountReportsPage = ({
  isHideAccountPlan,
  isHidePlaybook,
}: {
  isHidePlaybook: boolean;
  isHideAccountPlan: boolean;
}) => {
  const navigate = useNavigate();
  const { searchDict, setSearchValue } = useStateWithSearchParams<{
    subTab?: TabsEnum;
  }>({
    subTab: !isHideAccountPlan ? TabsEnum.plan : TabsEnum.playbook,
  });

  useEffect(() => {
    if (
      searchDict.subTab &&
      !Object.values(TabsEnum).includes(searchDict.subTab)
    ) {
      navigate(AppRoutes.CAMPAINGS, { replace: true });
    }
  }, [searchDict.subTab]);

  const tabsList = [
    { label: TabsEnum.plan, isHide: isHideAccountPlan },
    { label: TabsEnum.playbook, isHide: isHidePlaybook },
  ];

  return (
    <Stack flexDirection={"row"} gap={"32px"} flexGrow={1}>
      <Stack minWidth={"200px"} maxWidth={"200px"}>
        <ButtonTabs
          fullWidth={true}
          isVertical={true}
          currentTab={searchDict.subTab || ""}
          onChange={(tab) => setSearchValue("subTab", tab)}
          tabList={tabsList.map(({ label, isHide }) => (isHide ? "" : label))}
        />
      </Stack>
      {mapper[searchDict.subTab as TabsEnum]}
    </Stack>
  );
};
